export default {
  /**
   * 'a,b,c' -> ['a','b','c']
   */
  getKeys: (str) => {
    return str.split(',')
  },
  /**
   * ['a','b','c'] -> 'a,b,c'
   */
  keysToStr: (arr) => {
    return arr.joni(',')
  },

  isRecommend: {
    label: '是否推荐菜',
    values: {
      0: '否',
      1: '是'
    }
  },
  managerType: {
    label: '角色',
    values: {
      2: '企业管理员',
      3: '食堂管理员',
      4: '财务',
      5: '厨师长',
      6: '营养师'
    }
  },
  hallName: {
    label: '食堂名称'
  },
  payMode: {
    label: '支付模式',
    values: {
      1: '下单时扣款',
      2: '消费时付款'
    }
  },
  paySupports: {
    label: '支持付款方式',
    values: {
      alipay: '支付宝',
      weixinpay: '微信',
      common: '账户余额',
      cash: '现金'
    }
  },
  statusId: {
    label: '状态',
    values: {
      0: '暂停',
      1: '启用'
    }
  },
  hallType: {
    label: '类型',
    values: {
      0: '普通食堂',
      1: '炒菜食堂',
      2: '自助吧',
      3: '净菜食堂'
    }
  },
  orderSource: { // 全部来源 不传
    label: '订单来源',
    values: {
      common: '普通订单',
      pos: 'pos收银',
      phone: '电话订单',
      waiter: '点菜员订单',
      weixin: '微信订单'
    }
  },
  orderType: { // 全部 不传此参数
    label: '订单类型',
    values: {
      1: '普通类型',
      2: '他人代点',
      3: '临时点菜',
      4: '净菜',
      9: '营养餐',
      'cash': '现金收银'
    }
  },
  questionA: { // 全部 不传此参数
    label: '健康状态',
    values: {
      1: '健康',
      2: '有发烧、咳嗽、流涕等症状',
      3: '其他症状',
      null: '-'
    }
  },
  questionB: { // 全部 不传此参数
    label: '是否接触疫区人员',
    values: {
      1: '否',
      2: '是',
      null: '-'
    }
  },
  orderStatus: { // 全部 空
    label: '订单状态',
    values: {
      '-2': '已关闭',
      '-1': '已取消',
      '0': '未消费',
      '1': '已消费未评价',
      '2': '已消费已评价'
    },
    conditions: {
      '0,1,2': '已消费+未消费',
      '1,2': '已消费',
      '0': '未消费',
      '-1,-2': '已取消'
    }
  },
  payStatus: {
    label: '支付状态',
    conditions: {
      '1': '已付款',
      '0': '未付款',
      '-1': '已退款',
      '-2': '已关闭',
      '-3': '退款中',
      '-4': '线下已退款',
      '1,0,-1,-2,-3,-4': '全部'
    }
  },
  patientOrderStatus: {
    values: {
      'ORDERED': '已点餐',
      'DO_NOT_WANT_ORDER': '不想点餐',
      'NOT_ORDER': '没有点餐'
    }
  },
  needDistribute: { // 全部 不传
    label: '就餐模式',
    values: {
      'common': '堂食',
      'distribution': '配送',
      'pickup': '自提'
    }
  },
  periodName: {
    label: '餐段名称'
  },
  periodPicture: {
    label: '餐段图片'
  },
  stopOderTime: {
    label: '截止点餐时间'
  },
  stopCancelTime: {
    label: '截止取消时间'
  },
  remindTime: {
    label: '提醒点时间'
  },
  periodStartTime: {
    label: '餐段开始时间'
  },
  periodEndTime: {
    label: '餐段结束时间'
  },
  periodSupportMode: {
    label: '就餐模式',
    values: {
      common: '堂食',
      distribution: '配送',
      pickup: '自提'
    }
  },
  distribution: {
    label: '配送'
  },
  distributionRole: {
    label: '适用对象',
    values: {
      'common': '普通用户',
      'waiter': '点菜员'
    }
  },
  beginTime: {
    label: '开始时间'
  },
  endTime: {
    label: '结束时间'
  },
  distributionDefaultMark: {
    label: '是否为默认时段'
  },
  pickup: {
    label: '自提'
  },
  address: {
    label: '地址'
  },
  sex: {
    label: '性别',
    values: {
      '-1': '未知',
      '0': '男',
      '1': '女'
    }
  },
  tempUser: {
    label: '用户类型',
    values: {
      '0': '普通用户',
      '1': '临时用户'
    }
  },
  tagLimitType: {
    label: '标签种类',
    values: {
      0: '无限制标签',
      1: '限量类标签',
      2: '提醒类标签',
      3: '未预定人员标准餐标签'
    }
  },
  tagType: {
    label: '标签类型',
    values: {
      1: '普通标签',
      2: '营养标签'
    }
  },
  tagCheckType: {
    label: '限制类型',
    values: {
      1: '单品限制',
      2: '组合限制'
    }
  },
  tagVisible: {
    label: '是否显示',
    values: {
      1: '是',
      0: '否'
    }
  },
  tagName: {
    label: '标签名称'
  },
  userLeastAmount: {
    label: '最少份数'
  },
  userLimitAmount: {
    label: '最多份数'
  },
  cardStatus: {
    label: '是否绑定员工卡',
    values: {
      0: '否',
      1: '是'
    }
  },
  accountStatus: {
    label: '账户状态',
    values: {
      0: '未激活',
      1: '正常',
      2: '销户',
      3: '冻结'
    }
  },
  userCompanyStatus: {
    label: '用户状态',
    values: {
      1: '正常',
      3: '禁用'
    }
  },
  paymentReceiveStatus: {
    label: '到账状态',
    values: {
      1: '已到账',
      2: '赊账',
      3: '挂账'
    },
    conditions: {
      '2,3': '挂账+赊账',
      '2': '赊账',
      '3': '挂账'
    }
  },
  distributeStatus: {
    label: '配送状态',
    values: {
      0: '未配送',
      1: '已领取',
      3: '已配送'
    }
  },
  orderMode: {
    'common': '堂食',
    'distribution': '配送',
    'pickup': '自提'
  },
  payType: {
    label: '支付方式',
    values: {
      'weixinpay': '微信支付',
      'alipay': '支付宝支付',
      'common': '账户余额支付',
      'companycardpay': '公司卡支付',
      'cash': '现金支付',
      'abcqrpay': '掌银支付',
      'mobilebankingpay': '掌银支付'
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/resource.js